import { DataGrid } from './DataGrid';

/**
 * RowStore backed by an array.
 */
export class ArrayRowStore implements DataGrid.RowStore {
  private rows: DataGrid.Row[];

  public constructor(rows: DataGrid.Row[]) {
      this.rows = rows;
  }

  public getItems(start: number, end: number, rowHandler: (rows: DataGrid.Row[]) => void): void {
    rowHandler(this.rows);
  }
}
